namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailZastup extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GZastupReadDto;
        private newRecord: boolean;
        private detailObj: DetailZastupObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailZastupObj());
            this.detailObj.createBase({
                contentName: "detailZastup",
                contentCaption: "jres:33000699",  //RC 33000699 : Z�stup
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailZastup", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailZastupObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GZastupReadDto> {
        povolMimoIco: boolean;
        openFromOsoba: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.nazev_ref} x ${this.data.nazev_fun} x ${this.data.faze}`;
        }

        setSxsDetail(): string {
            return `${this.data.ixs_fun}#${this.data.ixs_ref}#${this.data.faze}#`;;
        }

        saveData(data: any, close: boolean) {
            data.NewRecord = this.options.newRecord;
            this.cnt.isl.Zastup.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.openFromOsoba = this.openFromOsoba;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailZastup", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.Zastup.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            if (this.openFromOsoba) {
                this.MakeSelectField("ico_ref", Gordic.Prefabs.Select.ginsico());
                this.MakeSelectField("ixs_ref", Gordic.Prefabs.Select.ginsref({
                    gridOpts: {
                        defaultProfile: {
                            columnList: "nazev,tit_pred,jmeno,prijmeni,tit_za,login_name,zkratka,ico"
                        }
                    }
                }), {
                    model: "model.ico=>value.ico,model.ixs_ref=value.ixs_ref",
                    dropdown: false,
                    flag: this.createFlagNemenne(),
                    change: (ev, ctx) => {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.ico) {
                                    this.cnt.findFields("ico_ref").gfield("setValue", { ico: ctx.value.ico }, false)
                                }
                            }
                        }
                    }
                });
                this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico());
                this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun",
                    serverFilters: (this.options.newRecord == true) ? {
                        aktivita: null,
                        ico: (this.povolMimoIco == true) ? null : new Gordic.Forms.Dependency("ico_ref", "ico", true, false, this.cnt.element)
                    } : { },
                    dropdown: false,
                    flag: this.createFlagNemenne(),
                    validators: [new Gordic.Validators.Required({ stopping: true }), this.validateIcoRefFun()],
                    change: (ev, ctx) => {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.ico) {
                                    this.cnt.findFields("ico").gfield("setValue", { ico: ctx.value.ico }, false)
                                }
                            }
                        }
                    }
                });


            } else {

                this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), { model: "model.ico=value.ico" });
                this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun",
                    serverFilters: (!this.data.ixs_fun) ? {
                        aktivita: null,
                        ico: (this.povolMimoIco == true) ? null : new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                    } : {},
                    dropdown: false,
                    flag: this.createFlagNemenne(),
                    change: (ev, ctx) => {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.ico) {
                                    this.cnt.findFields("ico").gfield("setValue", { ico: ctx.value.ico }, false)
                                }
                            }
                        }
                    }
                });

                this.MakeSelectField("ico_ref", Gordic.Prefabs.Select.ginsico());
                this.MakeSelectField("ixs_ref", Gordic.Prefabs.Select.ginsref({
                    gridOpts: {
                        defaultProfile: {
                            columnList: "nazev,tit_pred,jmeno,prijmeni,tit_za,login_name,zkratka,ico"
                        }
                    }
                }), {
                    model: "model.ico=>value.ico,model.ixs_ref=value.ixs_ref",
                    serverFilters: (this.options.newRecord == true) ? {
                        aktivita: 100,
                        ico: (this.povolMimoIco == true) ? null : new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                    } : {},
                    validators: [new Gordic.Validators.Required({ stopping: true }), this.validateIcoRefFun()],
                    dropdown: false,
                    flag: this.createFlagNemenne(),
                    change: (ev, ctx) => {
                        if (ctx.value) {
                            if (!Array.isArray(ctx.value)) {
                                if (ctx.value.ico) {
                                    this.cnt.findFields("ico_ref").gfield("setValue", { ico: ctx.value.ico }, false)
                                }
                            }
                        }
                    }
                });

            }



            this.MakeBoolField("faze_ginisall", {
                change: (ev, obj) => {
                    var faze_field_adm = $(".faze_field_adm").parent().parent();
                    var mimofaze_field_adm = $(".mimofaze_field_adm").parent().parent();
                    var fazefield = this.cnt.element.findFields("faze");
                    if (obj.value === false ) {
                        mimofaze_field_adm.hide();
                        faze_field_adm.show();
                        fazefield.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                    }
                    else {
                        mimofaze_field_adm.show();
                        fazefield.gfield("option", "validators",  [])
                        faze_field_adm.hide();
                    }
                    var form = this.cnt.element.findForms("detailZastupform");
                    var agenda_array = $(".agenda_array_adm").parent().parent();
                    if (obj.value == false) {
                        var value = form.findFields(".faze_field_adm").gfield("getValue");
                        if (value != null) {
                            if (value.faze == "GWAEPK05" || value.faze == "GSAEPK01")
                                agenda_array.show();
                            else
                                agenda_array.hide();
                        } else
                            agenda_array.hide();
                    } else {
                        var values: any[] = form.findFields(".mimofaze_field_adm").gfield("getValue");
                        if (values.filter(v => v.faze == "GWAEPK05").length > 0 && values.filter(v => v.faze == "GSAEPK01").length > 0)
                            agenda_array.hide();
                        else
                            agenda_array.show();
                    }
                },
                flag: this.createFlagNemenne()
            });

            this.MakeSelectField("faze", Gordic.Prefabs.Select.gincfaz(), {
                model: "model.faze=value.faze",
                customClass: "faze_field_adm",
                flag: this.createFlagNemenne(),
                change: (ev, changeObj) => {
                    if (changeObj.value != null) {
                        if (!Array.isArray(changeObj.value)) {
                            var agenda_array = $(".agenda_array_adm").parent().parent();
                            if (changeObj.value.faze == "GWAEPK05" || changeObj.value.faze == "GSAEPK01")
                                agenda_array.show();
                            else
                                agenda_array.hide();
                        }
                    }
                }
            });
            this.MakeSelectField("mimo_faze_array", Gordic.Prefabs.Select.gincfaz(), {
                model: "model.mimo_faze_array=value.faze",
                customClass: "mimofaze_field_adm",
                dropdown: false,
                multi: true,
                itemWidth: "",
                flag: this.createFlagNemenne(),
                change: (ev, changeObj) => {
                    if (changeObj.value != null) {
                        if (Array.isArray(changeObj.value)) {
                            if (changeObj.value[0] != null) {
                                var agenda_array = $(".agenda_array_adm").parent().parent();
                                if (changeObj.value.filter(f => f.faze == "GWAEPK05").length > 0 && (changeObj.value.filter(f => f.faze == "GSAEPK01").length > 0))
                                    agenda_array.hide();
                                else
                                    agenda_array.show();
                            }
                        }
                    }
                }
            });
            this.MakeSelectField("agenda_array", Gordic.Prefabs.Select.ginctag(), {
                multi: true,
                dropdown: false,
                itemWidth: "",
                customClass: "agenda_array_adm",
                model: "model.agenda_array=value.typ_ag",
            })

            this.MakeSelectField("priz_avizas", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_avizas=value.priz_an" });
            this.MakeField("dat_od" );
            this.MakeField("dat_do");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());

            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }


        private validateIcoRefFun(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                message: "jres:33000924", //RC 33000924 : I�O funk�n�ho m�sta a zastupuj�c� osoby je rozd�ln�. Z�stup nelze zalo�it.
                stopping: true,
                validate: (value, source) => {
                    if (this.povolMimoIco == false) {
                        let ref = this.cnt.findFields("ixs_ref").gfield("getValue");
                        let fun = this.cnt.findFields("ixs_fun").gfield("getValue");
                        if (ref.ico.trim() == fun.ico.trim())
                            return true;
                        return false;
                    }
                    return true;
                }
            })
        }
    }
}
